import React, { useEffect, useState } from 'react';
import Topbar from '../components/Header/Topbar';
import Navbar from '../components/Header/Navbar';
import Spinner from '../components/Spinner/Spinner';
import Footer from '../components/Footer/Footer';
import BackToTop from '../components/BackToTop/BackToTop';
import SEO from '../components/SEO/SEO';
import $ from 'jquery';

const pageHeaderStyle = {
  backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('/assets/solar-banaer.jpg')`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundAttachment: 'fixed',
  minHeight: '400px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const modalOverlayStyle = {
  display: 'none',
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  zIndex: 1000,
  alignItems: 'center',
  justifyContent: 'center',
};

const modalContentStyle = {
  position: 'relative',
  backgroundColor: 'white',
  borderRadius: '10px',
  maxWidth: '90%',
  maxHeight: '90vh',
  overflow: 'auto',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)',
};

const modalImageStyle = {
  width: '100%',
  height: 'auto',
  display: 'block',
};

const closeButtonStyle = {
  position: 'absolute',
  top: '15px',
  right: '15px',
  backgroundColor: '#DE400E',
  color: 'white',
  border: 'none',
  borderRadius: '50%',
  width: '40px',
  height: '40px',
  fontSize: '24px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1001,
};

const navButtonStyle = {
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: '#DE400E',
  color: 'white',
  border: 'none',
  borderRadius: '50%',
  width: '45px',
  height: '45px',
  fontSize: '20px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1001,
  transition: '0.3s',
};

const prevButtonStyle = {
  ...navButtonStyle,
  left: '15px',
};

const nextButtonStyle = {
  ...navButtonStyle,
  right: '15px',
};

const imageCounterStyle = {
  position: 'absolute',
  bottom: '15px',
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0, 0, 0, 0.6)',
  color: 'white',
  padding: '8px 15px',
  borderRadius: '20px',
  fontSize: '14px',
  zIndex: 1001,
};

const Gallery = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const galleryImages = [
    '/assets/Gallery-image1.jpg',
    '/assets/Gallery-image2.jpg',
    '/assets/Gallery-image3.jpg',
    '/assets/Galler-image4.jpg',
    // Add more images as needed
  ];

  useEffect(() => {
    // Initialize WOW.js
    if (window.WOW) {
      new window.WOW().init();
    }

    // Hide spinner
    setTimeout(() => {
      const spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.classList.remove('show');
      }
    }, 500);

    // Back to top functionality
    $(window).scroll(function () {
      if ($(this).scrollTop() > 300) {
        $('.back-to-top').fadeIn('slow');
      } else {
        $('.back-to-top').fadeOut('slow');
      }
    });

    $('.back-to-top').click(function (e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 1500, 'easeInOutExpo');
      return false;
    });

    // Keyboard navigation
    const handleKeyDown = (e) => {
      if (!showModal) return;
      
      if (e.key === 'ArrowLeft') {
        handlePrevImage();
      } else if (e.key === 'ArrowRight') {
        handleNextImage();
      } else if (e.key === 'Escape') {
        setShowModal(false);
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      $(window).off('scroll');
      $('.back-to-top').off('click');
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showModal]);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setShowModal(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setShowModal(false);
    document.body.style.overflow = 'auto';
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prev) => (prev === 0 ? galleryImages.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prev) => (prev === galleryImages.length - 1 ? 0 : prev + 1));
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <>
      <SEO 
        title="Gallery"
        description="View our project installations and product gallery at Galaxy Power System, Chidambaram. See our solar panel setups and battery installations."
        keywords="galaxy power gallery, solar installation photos, battery shop chidambaram images"
        canonicalUrl="https://galaxypowersystems.com/gallery"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Gallery', url: '/gallery' }
        ]}
      />
      <Spinner />
      <Topbar />
      <Navbar />
      
      {/* Page Header */}
      <div className="container-fluid page-header py-5 mb-5" style={pageHeaderStyle}>
        <div className="container py-5">
          <h1 className="display-3 text-white mb-3 animated slideInDown">Gallery</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb">
              <li className="breadcrumb-item"><a href="/" className="text-white">Home</a></li>
              <li className="breadcrumb-item text-white active" aria-current="page">Gallery</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Gallery Content */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-4">
            {galleryImages.map((image, index) => (
              <div key={index} className="col-lg-4 col-md-6 wow fadeInUp" data-wow-delay={`${(index % 3) * 0.2}s`}>
                <div className="gallery-item rounded overflow-hidden" style={{ cursor: 'pointer' }}>
                  <img 
                    src={image} 
                    className="img-fluid w-100" 
                    alt={`Gallery ${index + 1}`}
                    onClick={() => openModal(index)}
                    style={{ transition: 'transform 0.3s', cursor: 'pointer' }}
                    onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Modal Popup */}
      <div
        style={{
          ...modalOverlayStyle,
          display: showModal ? 'flex' : 'none',
        }}
        onClick={handleOverlayClick}
      >
        <div style={modalContentStyle}>
          {/* Close Button */}
          <button
            style={closeButtonStyle}
            onClick={closeModal}
            title="Close (ESC)"
          >
            ×
          </button>

          {/* Previous Button */}
          <button
            style={prevButtonStyle}
            onClick={handlePrevImage}
            title="Previous (Left Arrow)"
            onMouseEnter={(e) => e.target.style.backgroundColor = '#FF5733'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#DE400E'}
          >
            ‹
          </button>

          {/* Image */}
          <img
            src={galleryImages[currentImageIndex]}
            alt={`Gallery ${currentImageIndex + 1}`}
            style={modalImageStyle}
          />

          {/* Next Button */}
          <button
            style={nextButtonStyle}
            onClick={handleNextImage}
            title="Next (Right Arrow)"
            onMouseEnter={(e) => e.target.style.backgroundColor = '#FF5733'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#DE400E'}
          >
            ›
          </button>

          {/* Image Counter */}
          <div style={imageCounterStyle}>
            {currentImageIndex + 1} / {galleryImages.length}
          </div>
        </div>
      </div>

      <Footer />
      
      {/* Use the React BackToTop component */}
      <BackToTop />
    </>
  );
};

export default Gallery;